
import { MSEnum } from '@/common/enumeration';
export default {
	updateSubscriberConfig(state, payload) {
		state.SubscriberConfig = payload;
	},

	updateCheckLicenseMeInvoice(state, payload) {
		if (!state.SubscriberConfig) return;
		state.SubscriberConfig.IsLicenseMeInvoice = payload;
	},

	updateIdentificationNumberStatusAsync(state, payload) {
		if (!state.SubscriberConfig) return;
		if (payload && payload.IdentificationNumberStatus) {
			state.SubscriberConfig.IdentificationNumberStatus = payload.IdentificationNumberStatus;
			state.SubscriberConfig.IsUpdateIdentificationNumber = payload.IdentificationNumberStatus === MSEnum.UpdateStatusEnum.Success ? true : false;
		}
	},

	updateShowedUpdateIdentificationPopup(state, value) {
		if (state.SubscriberConfig) {
			state.SubscriberConfig.IsShowedUpdateIdentificationPopup = value;
		}
	},
};
